import { sample } from "effector";

import { updateApp } from "@entities/app/model/app";
import { closeSession, newSession } from "@entities/session";

import { refreshSessionFx } from "./refresh-session";

sample({
  clock: refreshSessionFx.doneData,
  target: newSession,
});

sample({
  clock: refreshSessionFx.fail,
  target: closeSession,
});

sample({
  clock: refreshSessionFx.finally,
  fn: () => ({ isInitialized: true }),
  target: updateApp,
});
